import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UmbrellaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"umbrella"}/>
}
